import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./ThankyouPage.css";
import { ThankyouContext } from "../ThankyouView";
import ThanksImg from "../../../../assests/images/thankyouImage.svg";
import Button from "../../../../components/ButtonComponent/Button";
import RouteConstant from "../../../../constants/routesContent.json";

const ThankyouView = ({ textContents }) => {
const { thankyouMessage } = useContext(ThankyouContext);
  const navigate = useNavigate();
  return (
    <div>
      <div className="thankyouBox">
        <div className="col-xl-5 col-md-6 col-sm-6 col-12 boxCenterThankyou">
          <img src={ThanksImg} className="logoThankyou" />
          <h5 className="mt-5 titleThankyou">{textContents.thankyou}</h5>
          <div className="messageThankyou">
            <p className="textThankyou">
             {thankyouMessage}
            </p>
          </div>
          <div className="thankyouBtns">
          <Button
                text="OK"
                onClick={() => navigate(RouteConstant.INTENT_HISTORY)}
              />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankyouView;
